<template>
  <div
    ref="conteneurImg"
    class="d-flex flex-column focal-point h-100"
    :class="jel_getClassObject(content)"
  >
    <b-img-lazy
      :src="jel_getImageSrcFocalPoint(content.image, content.formatRatio, largeur)"
      :alt="content.altImage ? content.altImage : ''"
      :show="show"
      :class="getImageSize"
      :onload="setIsLoaded()"
    />
  </div>
</template>

<script>
export default {
  name: 'MediaImageFocalPoint',
  props: {
    content: { type: Object, required: true },
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      largeur: null,
      delaiPreload: 3000,
    };
  },
  computed: {
    getImageSize() {
      if (this.content.isBackground) {
        return 'w-100 h-100';
      }
      if (this.content.isLogo) {
        return 'mw-100 mh-100 m-auto';
      }
      return 'h-100';
    },
  },
  mounted() {
    const self = this;
    this.$nextTick(function () {
      self.getWindowWidth();
    });
  },
  methods: {
    getWindowWidth() {
      if (this.$refs.conteneurImg) {
        this.largeur = this.$refs.conteneurImg.clientWidth;
      }
    },
    setIsLoaded() {
      if (this.content.preload) {
        setTimeout(() => this.$emit('lazyImgLoaded', 'loading'), this.delaiPreload);
        this.delaiPreload = 1000;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  &.droite {
    img {
      align-self: flex-end !important;
    }
  }
  &.centre {
    img {
      align-self: center !important;
    }
  }
  &.gauche {
    img {
      margin: 0;
      margin-right: auto;
      height: 100%;
    }
  }
}
</style>
